import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import useDiscord from '@/components/DiscordAuthFlow/useDiscord';
import Button from '@/components/Forms/Button';
import { IS_DISCORD_ACTIVITY } from '@/globals';

import * as styles from './styles.module.scss';
import { useAppSelector } from '@/state/store';

export interface DiscordAuthFlowMethods {
    authorize: () => void;
    openExternalLink: (url: string) => void;
    completeQuest: () => void;
}

const DiscordAuthFlow = forwardRef<DiscordAuthFlowMethods, any>((props, ref) => {
    const { authorize, openExternalLink, user, authError, authDenied, quest, authLoading } = useDiscord();
    const d = useAppSelector((state) => state.discord);

    useImperativeHandle(ref, () => ({
        authorize,
        openExternalLink,
        completeQuest: () => {
            if (quest) {
                quest.complete();
            }
        },
    }));

    if (!IS_DISCORD_ACTIVITY && window.location.hostname !== 'localhost') {
        return <></>;
    }

    if (!user) {
        if (authLoading) {
            return <TextOverlay message="Authenticating..." />;
        }

        if (authDenied) {
            return <AuthRequiredOverlay authorise={authorize} />;
        }
        if (authError) {
            return <AuthErrorOverlay authorise={authorize} />;
        }
        // If there's no user and it's not in any of the other states, show the loader
        return <TextOverlay message="Discord SDK Loading..." />;
    }

    // return (
    //     <>
    //         <div className={styles.info}>{JSON.stringify(d, null, 4)}</div>
    //     </>
    // );
    return <></>;
});

function OverlayWrapper({ children }) {
    return (
        <div className={styles.overlayWrapper}>
            <div className={styles.overlayContentWrapper}>
                <img src="/assets/themes/mimas/IMF-Loader.gif" className={styles.logo} />
                {children}
            </div>
        </div>
    );
}
function TextOverlay({ message }: { message?: string }) {
    return (
        <OverlayWrapper>
            <div>{message}</div>
        </OverlayWrapper>
    );
}

function AuthRequiredOverlay({ authorise }: { authorise: () => void }) {
    return (
        <OverlayWrapper>
            <div className={styles.authCopy}>Please login with your Discord account to play this experience.</div>
            <Button
                onClick={() => {
                    authorise();
                }}
                className={styles.loginButton}
            >
                Log In
            </Button>
        </OverlayWrapper>
    );
}

function AuthErrorOverlay({ authorise }: { authorise: () => void }) {
    return (
        <OverlayWrapper>
            <div className={styles.authCopy}>Authorization error. Please try logging in again.</div>
            <Button
                onClick={() => {
                    authorise();
                }}
                className={styles.loginButton}
            >
                Try Again
            </Button>
        </OverlayWrapper>
    );
}

export function QuestUnenrolledNotice({ gotoEnroll }: { gotoEnroll?: () => void }) {
    const [collapsed, setCollapsed] = useState(false);
    function renderCollapsed() {
        return (
            <span className={styles.enrolButton} onClick={gotoEnroll}>
                Join Quest
            </span>
        );
    }
    function renderFull() {
        return (
            <div>
                <span>Join the quest to get your reward.</span>
                <span className={styles.enrolButton} onClick={gotoEnroll}>
                    Join Quest (TODO)
                </span>
                <span
                    className={styles.enrolButton}
                    onClick={() => {
                        setCollapsed(!collapsed);
                    }}
                >
                    &lt;
                </span>
            </div>
        );
    }
    return (
        <div className={styles.questUnenrolledNotice + ' ' + (collapsed ? styles.collapsed : '')}>
            {collapsed ? renderCollapsed() : renderFull()}
        </div>
    );
}

export default DiscordAuthFlow;
